import { useContext, useEffect, useMemo, useState } from "react"
import { schoolContext } from "../providers/school.provider"
import { getPlayerSeasonRecoveryLessons } from "../utils/firestore.utils"
import { getSeasonBounds, playerAbsencesByCourse } from "../utils/substitutes.utils"

// Le assenze e i recuperi di un allievo nella stagione, per corso, per la sua
// scheda. Una lettura sola quando si apre l'allievo, e solo delle sue lezioni
// che contano per i recuperi (`tracksRecovery`): non tutte quelle della
// stagione. `version` che cambia la rifà, dopo una lezione modificata.
const usePlayerSeasonAbsences = (playerID, version) => {
	const { selectedSchool } = useContext(schoolContext)
	const season = useMemo(() => getSeasonBounds(new Date()), [])

	const [lessons, setLessons] = useState(null)

	useEffect(() => {
		if (!selectedSchool || !playerID) return
		let isCurrent = true
		getPlayerSeasonRecoveryLessons(selectedSchool, playerID, season.start)
			.then(read => isCurrent && setLessons(read))
			// senza la lettura la scheda resta com'era, senza il conto
			.catch(error => console.error("Assenze dell'allievo non lette:", error))
		return () => {
			isCurrent = false
		}
	}, [selectedSchool, playerID, season, version])

	const byCourse = useMemo(() => playerAbsencesByCourse(lessons, playerID), [lessons, playerID])

	return { byCourse, season }
}

export default usePlayerSeasonAbsences
